import React from 'react';

export default () => {
    return <div>404</div>
}